<template>
  <div class="page-layout">
    <PageHeader />
    <div class="landing-page-wrapper content-wrapper">
      <div class="landing-page">
        <div class="landing-page__col landing-page__col--text">
          <h1>{{ Content.heading }}</h1>
          <p>{{ Content.bodyText }}</p>
          <ul>
            <li
              v-for="(item, idx) in Content.listItems"
              :key="idx"
            >
              {{ item }}
            </li>
          </ul>
          <a
            href="#"
            class="buttonz buttonz--primary buttonz--full buttonz--padded"
            @click.prevent="resetQuizSession"
            @keyup.enter.prevent="resetQuizSession"
          >
            {{ Content.button.text }}
          </a>
          <p class="footnote">
            {{ Content.footnote }}
          </p>
        </div>
        <div class="landing-page__col landing-page__col--hero">
          <img
            :src="imageBaseUrl + '/images/img_landing3.svg'"
            alt="Landing page hero"
          >
        </div>
      </div>
    </div>
    <PageFooter />
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import Content from '@/components/landingpage/Content.json';
import PageHeader from '@/components/layout/PageHeader.vue';
import PageFooter from '@/components/layout/PageFooter.vue';
import useQuizStore from '@/stores/quiz';

const quizStore = useQuizStore();

const router = useRouter();

const imageBaseUrl = process.env.VUE_APP_IMAGE_BASE_URL;

const resetQuizSession = () => {
  localStorage.clear();
  quizStore.resetPostStateCode();
  router.push({
    name: 'quiz',
  });
};
</script>
<style scoped lang="scss">
  .landing-page-wrapper {
    background-color: #1E475A;
  }
  .landing-page {
    display: flex;
    flex-direction: column;
    padding: 40px 16px;
    align-items: center;
    max-width: $component_max_width;
    box-sizing: border-box;
    margin: 0 auto;
    color: white;

    @include med-breakpoint() {
      flex-direction: row;
      padding: 40px 20px;
    }

    h1 {
      color: white;
      font-size: 40px;
      line-height: 46px;
      margin: 0;
      padding-bottom: 8px;
    }

    p {
      font-size: 22px;
      line-height: 28px;
      padding-bottom: 20px;
      margin: 0;

      &.footnote {
        font-size: 16px;
        line-height: 24px;
        padding-top: 20px;
      }
    }

    ul {
      margin: 0 0 16px;
      padding: 0;
    }

    li {
      font-size: 19px;
      line-height: 32px;
      padding-bottom: 16px;
      padding-left: 34px;
      position: relative;
      margin: 0;

      &:before {
        font-family: 'icons';
        content: "\e917";
        color: $colour_green;
        position: absolute;
        left: 0;
        top: 0;
      }
    }

    &__col {
      width: 100%;
      &--text {
        flex-shrink: 0;
        @include med-breakpoint() {
          width: 375px;
          margin-right: 64px;
        }
      }
      &--hero {
        display: flex;
        flex-direction: column;
        flex-grow: 1;

        img {
          width: 100%;
        }

        @include med-breakpoint {
          // min-height: 430px;
          // // justify-content: center;
          // align-items: center;
        }

        &:after {
          content: '';
          background-size: cover;
          background-repeat: no-repeat;
          background-image: url($VUE_APP_IMAGE_BASE_URL + '/images/img_landing3.svg');
          width: 100%;
          height: 100%;
          background-position: center center;
        }

        // &:before,
        // &:after {
        //   content: '';
        //   background-size: cover;
        //   background-repeat: no-repeat;
        // }

        // &:before {
        //   background-position: left center;
        // }

        // &:after {
        //   content: '';
        //   background-image: url($VUE_APP_IMAGE_BASE_URL + '/images/img_landing1.svg');
        //   width: 100%;
        //   height: 142px;
        //   background-position: center center;
        // }

        // @include med-breakpoint() {
        //   &:before,
        //   &:after {
        //     background-size: contain;
        //   }

        //   &:before {
        //     background-image: url($VUE_APP_IMAGE_BASE_URL + '/images/img_landing3.svg');
        //     width: 80%;
        //     height: 124px;
        //     margin-bottom: 42px;
        //     background-position: center bottom;
        //   }

        //   &:after {
        //     background-position: center top;
        //   }
        // }
      }
    }
  }
</style>
